export default "__VITE_ASSET__Dob_AwhC__"